import React, { Component } from 'react'
import Projectdetail from './Projectdetail'
import Imagerow from './components/Imagerow'
import Updates from './components/Projupdates'

export class Blueleaf extends Component {
  

  render() {
    return (
      <React.Fragment>
        <Projectdetail
          image="assets/img/herobg-proj-detail-blueleaf.jpg"
          heading="Blueleaf University"
          content={[
            <>
              <p>
                This is a very simple, fictional University site that's built
                with Wordpress, including a custom theme, that's built from
                scratch. Included in this theme are custom post types such
                Professors, Programs, and Events posts which has custom fields
                unique to that post type. It also has relationships between
                different pieces of content, such as matching a professor with a
                major or program that they teach.
              </p>

              <p>
                It also contains a javascript powered live search feature. It
                also uses the Wordpress API, to create a feature called my
                notes. Which is a very small app where a user type in notes for
                a class and save it to the Wordpress API.
              </p>
            </>,
          ]}
          website="http://www.mlmontheweb.com/projects/blueleafuniv/"
          github="https://github.com/Jimmyelvis/blueleafuniv"
          techs={[
            <>
              <li>Wordpress</li>
              <li>JavaScript</li>
              <li>Ajax</li>
            </>,
          ]}
          updates={[
            <>
              <h2 className="heading-2">Recent Updates</h2>

              <div className="updates">
                <Updates
                  heading="UPDATE 1/10/2020"
                  desc={[
                    <>
                      <p>
                        Added a JQuery slider to the front. In addition to users
                        have the ability to choose how many slides will display
                        in the slider as well as the abitlity to choose the
                        background image for each slide, and whatever content
                        they want on each slide. Also added an Ajax search bar
                        for a better user experience
                      </p>
                    </>,
                  ]}
                  itemImage={[
                    {
                      fullimage: "assets/img/screenshots/lrg/gergre.jpg",
                      screenshot: "assets/img/screenshots/lrg/gergre.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/r32r32r32.jpg",
                      screenshot: "assets/img/screenshots/lrg/r32r32r32.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/gergegr.jpg",
                      screenshot: "assets/img/screenshots/lrg/gergegr.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/3r2r33.jpg",
                      screenshot: "assets/img/screenshots/lrg/3r2r33.jpg",
                    },
                  ]}
                  gallery="UPDATE 1/10/2020"
                />
             
              </div>
            </>,
          ]}
          images={[
            <>
              <Imagerow images="assets/img/screenshots/lrg/blueleaf-1.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-2.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-3.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-4.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-5.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-6.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-7.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-8.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-9.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-10.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-11.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/blueleaf-12.jpg" />
            </>,
          ]}
        />
      </React.Fragment>
    );
  }
}

export default Blueleaf
